<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid >
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12">
							<v-toolbar dark color="primary">
								<v-toolbar-title>Login</v-toolbar-title>
							</v-toolbar>
							<v-card-text>
								<v-form>
									<v-text-field prepend-icon="fas fa-user" name="login" label="Login" type="text" v-model="auth.username"></v-text-field>
									<v-text-field id="password" prepend-icon="fas fa-lock"
										:append-icon="pwVisible ? 'far fa-eye' : 'far fa-eye-slash'"
										:type="pwVisible ? 'text' : 'password'"
										@click:append="pwVisible = !pwVisible"
										name="password" label="Password" v-model="auth.password"></v-text-field>
								</v-form>
								<v-alert :value="serverDown" type="error">
									Server unavailable
								</v-alert>
								<v-alert :value="invalid" type="warning">
									Invalid login
								</v-alert>
							</v-card-text>
							<v-card-actions>
								<router-link :to="{ name: 'forgotpassword' }" class="ml-2">Forgot Password</router-link>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="login" :loading="checking"
									:disabled="!auth.username || !auth.password">Login</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import analysisApi from "../analysisApi";
import { actionTypes } from "../store-types";

export default {
	data() {
		return {
			auth: {
				username: null,
				password: null,
			},
			pwVisible: false,
			invalid: false,
			serverDown: false,
			checking: false,
		};
	},
	methods: {
		login() {
			this.invalid = false;
			this.serverDown = false;
			this.checking = true;

			analysisApi.login(this.auth).then((r) => {
				this.checking = false;

				const token = r.data.token;

				return this.$store.dispatch(actionTypes.SAVE_LOGIN, token);
			}).catch((e) => {
				this.checking = false;

				if (e && e.response && e.response.status === 401) {
					this.invalid = true;
				} else {
					this.serverDown = true;
				}
			});
		},
	},
};
</script>
